import React from 'react';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';

const Loader = () => {


  return (
    <>
      <div id="global-loader">
        <div className="loader-img">
          <ImageWithBasePath src="assets/img/loader.webp" className="img-fluid" alt="Global" />
        </div>
      </div>
    </>
  );
};

export default Loader;
